import Container from 'react-bootstrap/Container';
import NewsGetAll from '../services/NewsGetAll';

function News() {
  return (
    <div>
      <Container>
        <NewsGetAll />
      </Container>
    </div>
  );
}

export default News;